import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
// import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const ThankYouPomlad2025 = () => {

  return (
    <>
      <Header />
      <Hero image="thankyou-pomlad-2025.jpg" yPos="bottom" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={8} sm={12} xs={12} className="p-3">
                    <h1>Hvala za vaš odgovor!</h1>
                    <p className="text-left">
                      Pomlad prinaša svežo energijo in nove priložnosti – naj bo to sproščanje ob dobrem žaru, prvi koraki v naravi, prenova doma ali načrtovanje izleta.
                    </p>
                    <p className="text-left">
                      <b>Želimo vam, da to pomlad preživite lahkotno, nasmejano in v družbi stvari, ki vam največ pomenijo.</b>
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}